import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/owlBranding/userExperience1.webp'

export const UserExperienceBannerOne: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'user experience'} />
)
